import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { WithWorkspaceId } from '~/types/common';
import { dashboardProcessApi } from '~/utils/api';

export const getActivitiesByProcessId = async ({
  workspaceId,
  processId,
}: { processId: string } & WithWorkspaceId) =>
  dashboardProcessApi.get<RcInstanceDTO.Activity[]>(
    `/workspaces/${workspaceId}/processes/${processId}/activities`,
  );

export const getActivity = async ({
  workspaceId,
  processId,
  activityId,
}: { processId: string; activityId: string } & WithWorkspaceId) =>
  dashboardProcessApi.get<RcInstanceDTO.Activity>(
    `/workspaces/${workspaceId}/processes/${processId}/activities/${activityId}`,
  );

export const deleteActivity = async ({
  workspaceId,
  processId,
  activityId,
}: { processId: string; activityId: string } & WithWorkspaceId) =>
  dashboardProcessApi.delete<RcInstanceDTO.Activity[]>(
    `/workspaces/${workspaceId}/processes/${processId}/activities/${activityId}`,
  );

export const editActivity = async ({
  workspaceId,
  processId,
  activityId,
  activity,
}: {
  processId: string;
  activityId: string;
  activity: RcInstanceDTO.Activity;
} & WithWorkspaceId) =>
  dashboardProcessApi.put<RcInstanceDTO.Activity>(
    `/workspaces/${workspaceId}/processes/${processId}/activities/${activityId}`,
    {
      ...activity,
    },
  );

// TODO: Remove and replace this type with `RcInstanceDTO.Activity` once the endpoint accepts it
export type CreateActivityPayload = {
  name?: string;
  templateId: string;
  processId: string;
  runtimeType?: string;
  runtimeId?: string;
  containerImageId?: string;
  environmentGroupId?: string;
  onDemandRuntimeId?: string;
};

export const create = async ({
  workspaceId,
  processId,
  payload,
}: { processId: string; payload: CreateActivityPayload } & WithWorkspaceId) =>
  dashboardProcessApi.post<RcInstanceDTO.Activity>(
    `/workspaces/${workspaceId}/processes/${processId}/activities`,
    {
      ...payload,
    },
  );

export const listWorkspaceActivities = async ({ workspaceId }: WithWorkspaceId) =>
  dashboardProcessApi.get<RcInstanceDTO.Activity[]>(`/workspaces/${workspaceId}/activities`);
